import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import logoImg from "../assets/logo2.png"; 

export const exportarAlocacao = (
  aluno,
  referencia,
  mensalidades = [],
  totais = {},
  formato = "pdf",
  nomeEscola = "Escola Vida Abundante",
  emailEscola = "escolavidaabundante7gmail.com",
  localizacao = "Machava Km 15 Nkomane",
  nuit = "700067254",
  operador = "Usuário Logado",
  desenvolvedor = "Chaúca Creative"
) => {
  if (!Array.isArray(mensalidades) || mensalidades.length === 0) {
    alert("Nenhum dado para exportar.");
    return;
  }

  const nomeArquivo = `ACADE_Alocacao_${aluno.codigo || "aluno"}_${new Date()
    .toLocaleDateString("pt-AO")
    .replace(/\//g, "-")}`;

  const colunas = [
    "Ano",
    "Mês",
    "Status",
    "Valor Alocado",
    "Multa",
    "Total Pago",
    "Data Movimento",
    "Detalhes",
  ];

  const dadosFormatados = mensalidades.map((m) => {
    const normalizar = (v) =>
      v !== undefined && v !== null && v !== "" ? v : "—";
    return {
       "Ano": normalizar(m.ano),
       "Mês": normalizar(m.mesNome || m.mes),
       "Status": normalizar(m.status),
       "Valor Alocado": `${Number(m.valor || 0).toFixed(2)} MZN`,
       "Multa": m.multa ? `${Number(m.multa).toFixed(2)} MZN` : "—",
       "Total Pago": `${Number(m.valor_pago || 0).toFixed(2)} MZN`,
       "Data Movimento": m.atualizado_em
       ? new Date(m.atualizado_em).toLocaleDateString("pt-AO")
       : "—",
      "Detalhes": normalizar(m.observacao),
    };
  });

  if (formato === "pdf") {
    const doc = new jsPDF("landscape");
    const img = new Image();
    img.src = logoImg;

    img.onload = () => {
      const imgWidth = 40;
      const imgHeight = (img.height * imgWidth) / img.width;
      doc.addImage(logoImg, "PNG", 10, 8, imgWidth, imgHeight);

      // Cabeçalho esquerdo
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text("ACADE – Gestor Escolar", 60, 15);

      doc.setFont("helvetica", "italic");
      doc.setFontSize(12);
      doc.text("Relatório de Alocação Mensal", 60, 23);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.text(nomeEscola, 60, 30);
      doc.text(`Email: ${emailEscola}`, 60, 36);
      doc.text(`Localização: ${localizacao}`, 60, 42);
      doc.text(`NUIT: ${nuit}`, 60, 48);

      // Dados do aluno
      doc.text(
        `Aluno: ${aluno.nome || "—"} (${aluno.codigo || "—"}) | Referência: ${
          referencia || "—"
        }`,
        14,
        55
      );

      // Cabeçalho direito
      const now = new Date().toLocaleString("pt-AO");
      doc.text(`Data: ${now}`, 270, 15, { align: "right" });
      doc.text(`Operador: ${operador}`, 270, 21, { align: "right" });

      autoTable(doc, {
        head: [colunas],
        body: dadosFormatados.map((item) => colunas.map((col) => item[col])),
        startY: 65,
        styles: { fontSize: 10, cellPadding: 3 },
        headStyles: {
          fillColor: [22, 160, 133],
          textColor: 255,
          halign: "center",
        },
        didDrawPage: (data) => {
          const pageHeight = doc.internal.pageSize.height;
          const pageWidth = doc.internal.pageSize.width;
          const pageNumber = doc.internal.getNumberOfPages();

          // Totais
          if (data.cursor.y + 20 < pageHeight - 20) {
            doc.setFont("helvetica", "bold");
            doc.text(
              `Totais → Multa: MZN ${Number(totais.multa || 0).toFixed(
                2
              )} | Pago: MZN ${Number(totais.valorPago || 0).toFixed(2)}`,
              14,
              data.cursor.y + 15
            );
          }

          // Rodapé
          doc.setFont("helvetica", "normal");
          doc.setFontSize(9);
          doc.text(
            `Software: ACADE-Gestor Escolar | Página ${pageNumber} de ${pageNumber}`,
            14,
            pageHeight - 15
          );

          doc.setDrawColor(150);
          doc.line(14, pageHeight - 13, pageWidth - 14, pageHeight - 13);

          doc.setFont("helvetica", "italic");
          doc.text(
            `Desenvolvido por ${desenvolvedor}`,
            pageWidth - 14,
            pageHeight - 8,
            { align: "right" }
          );
        },
      });

      doc.save(`${nomeArquivo}.pdf`);
    };
  } else if (formato === "excel") {
    const ws = XLSX.utils.json_to_sheet(dadosFormatados, { header: colunas });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Alocacao");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      `${nomeArquivo}.xlsx`
    );
  } else if (formato === "csv") {
    const csvLinhas = [
      colunas.join(","),
      ...dadosFormatados.map((item) =>
        colunas.map((col) => `"${item[col]}"`).join(",")
      ),
    ];
    saveAs(
      new Blob([csvLinhas.join("\n")], { type: "text/csv;charset=utf-8;" }),
      `${nomeArquivo}.csv`
    );
  } else {
    alert("Formato não suportado.");
  }
};
